type MaybeClassName = string | number | boolean | undefined | null;

export function classNames(...classes: MaybeClassName[]): string {
  function joinClasses(acc: string, cls: MaybeClassName) {
    if (typeof cls === "string" && cls.length > 0) {
      return `${acc} ${cls.trim()}`;
    }

    if (typeof cls === "number" && cls > 0) {
      return `${acc} ${cls}`;
    }

    return acc;
  }

  return [...new Set(classes)].reduce(joinClasses, "").trim();
}

export type RisrState = "draft" | "published" | "archived";
export type RisrColor = "primary" | "accent" | "warn" | "neutral";

const stateToColorMap: Record<RisrState, RisrColor> = {
  draft: "accent",
  published: "primary",
  archived: "warn",
};

export function getSlotColor(state: RisrState | undefined): RisrColor {
  return state ? (stateToColorMap[state] ?? "neutral") : "neutral";
}
